import config from '@/config';

const getShortTimezone = function(): string {
  const shortTimezone = localStorage.getItem('shortTimezone');
  return shortTimezone;
};

export const getMeetingDateAndTime = (date: string | number): string => {
  if (!date) return;

  const dateObj = new Date(date);
  let [day, month, minutes]: number[] | string[] = [
    dateObj.getDate(),
    dateObj.getMonth() + 1,
    dateObj.getMinutes(),
  ];

  [day, month, minutes] = [day, month, minutes].map((num) =>
    num < 10 ? `0${num}` : num.toString(),
  );

  let finalDate = `${day}/${month}/${dateObj.getFullYear()} ${dateObj.getHours()}:${minutes}`;

  if (!date.toString().includes('T')) finalDate = finalDate.split(' ')[0];

  if (!config.isOnTestEnv) {
    finalDate += ` ${getShortTimezone()}`;
  }

  return finalDate;
};

export const getYYYYMMDDDate = (date: string | number): string => {
  const dateObj = new Date(date);
  const month = dateObj.getMonth() + 1;
  const day = dateObj.getDate();

  return `${dateObj.getFullYear()}-${month < 10 ? '0' + month : month}-${
    day < 10 ? '0' + day : day
  }`;
};

export default getMeetingDateAndTime;
